import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
}
const baseClasses = 'inline-flex items-center justify-center gap-2 px-8 py-4 text-lg font-bold text-white bg-orange rounded-full shadow-[0_10px_24px_rgba(232,98,15,0.28)] hover:bg-orange-dark transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-orange/40 text-center';

/** Primary conversion button — always links to checkout and fires InitiateCheckout. */
export function Button({
  children,
  className = ''
}: ButtonProps) {
  return <motion.a href={CHECKOUT_URL} onClick={trackCheckout} className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.15,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-84" data-mp="287tcjuxw4zdu">
      {children}
    </motion.a>;
}